<template>
  <div>
    <div class="search-box ban3" :class="{ 'open': searchMore }">
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入产品名称" clearable />
      </div>
      <div class="input-item">
        <span class="label">产品编码</span>
        <Input v-model="searchParams.productCode" placeholder="请输入产品编码" clearable />
      </div>
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyCode" transfer placeholder="请选择保司" clearable filterable>
          <Option v-for="(item, index) in companyList" :value="item.code" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">长短险</span>
        <Select v-model="searchParams.productType" transfer placeholder="请选择上架状态" clearable>
          <Option value="1">长险</Option>
          <Option value="2">短险</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">上架状态</span>
        <Select v-model="searchParams.publishStatus" transfer placeholder="请选择上架状态" clearable>
          <Option value="1">已下架</Option>
          <Option value="2">已上架</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">销售状态</span>
        <Select v-model="searchParams.salesStatus" transfer placeholder="请选择销售状态" clearable>
          <Option value="1">停售</Option>
          <Option value="2">在售</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">供应商类型</span>
        <RadioGroup v-model="searchParams.supplierType" @on-change="changeOriginSupplierType">
          <Radio label="">全部</Radio>
          <Radio label="1">保司</Radio>
          <Radio label="2">通道</Radio>
        </RadioGroup>
      </div>
      <div v-if="searchParams.supplierType" class="input-item">
        <span class="label">供应商</span>
        <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
          <Option v-for="item in supplierList" :key="item.value" :value="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">业务类别</span>
        <Select v-model="searchParams.sellType" clearable transfer>
          <Option value="1">网销</Option>
          <Option value="3">经代</Option>
        </Select>
      </div>

      <div class="btn-item">
        <Button class="reset-btn" v-if="searchMore" @click="searchMore = false">收起</Button>
        <div class="close-open" v-else @click="searchMore = true">展开</div>
        <Button type="primary" @click="searchAjax">查询</Button>
      </div>
    </div>

    <div class="content" v-if="productType==1">
      <Tabs v-model="tabActive" @on-click="searchAjax(true)" v-if="status == '0' || isAdd == 1">
        <TabPane label="全部" name="0"></TabPane>
        <TabPane :label="item.name" :name="item.id" v-for="(item, i) in themeList" :key="i"></TabPane>
      </Tabs>
    </div>

    <!-- 工具栏 -->
    <div class="tools-box">
      <div class="left-box">
        <Checkbox v-model="isAll" @on-change="selectAll">全部产品</Checkbox>
        <span class="text"
          >已选择<span>{{ isAll ? total : selectArr.length }}</span
          >项,共<span>{{ total }}</span
          >款产品</span
        >
      </div>
      <div class="right-box">
        <!-- <div class="sync-switch">
          <span class="label">是否同步产品</span>
          <i-switch v-model="syncProductTy" :true-value="1" :false-value="0" @on-change='changeSyncProductType'>
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </div> -->
        <Button type="primary" ghost @click="batchDelete">批量删除</Button>
        <Button type="warning" @click="$emit('addSaveForm')">新增</Button>        
      </div>
    </div>

    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
        <template slot-scope="{ row }" slot="productName">
          <Tooltip class="productName" :content="row.productName">
            <span @click="showEdit(row)">{{ row.productName }}</span>
          </Tooltip>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="openGradeConfig(row)">费用配置</span>
          <span class="table-btn" @click="del(row)">删除</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="changePage" style="text-align: center; margin-top: 20px" />
    </div>

    <!-- 费用配置 -->
    <newGradeConfig :status="status" ref="gradeConfig" />
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import newGradeConfig from './newGradeConfig';

export default {
  mixins: [pageTool, common],
  props: ['isAdd', 'status', 'productType', 'activityId', 'syncProductType'],
  components: { newGradeConfig },
  data() {
    return {
      supplierList: [],
      companyList: [],
      themeList: [],
      tabActive: '0',
      syncProductTy: this.syncProductType,
      isAll: false,
      selectArr: [], //表格选择的数据
      columns: [
        {
          type: 'selection',
          width: 100,
          align: 'center'
        },
        {
          title: '产品编码',
          key: 'productCode',
          align: 'center',
          width: 100
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          slot: 'productName',
          width: '400'
        },
        {
          title: '保险公司',
          key: 'companyName',
          align: 'center'
        },
        {
          title: '供应商',
          key: 'supplierName',
          align: 'center'
        },
        {
          title: '业务类别',
          key: 'sellType',
          align: 'center',
          render(h, params) {
            if (params.row.sellType.indexOf('1') != -1) {
              return <Tag color="blue">网销</Tag>;
            } else if (params.row.sellType.indexOf('3') != -1) {
              return <Tag color="blue">经代</Tag>;
            }
          }
        },
        {
          title: '上架状态',
          slot: 'publishStatus',
          align: 'center',
          render(h, params) {
            if (params.row.publishStatus == 2) {
              return <Tag color="blue">上架</Tag>;
            } else {
              return <Tag color="red">下架</Tag>;
            }
          }
        },
        {
          title: '销售状态',
          slot: 'salesStatus',
          align: 'center',
          render(h, params) {
            if (params.row.salesStatus == 2) {
              return <Tag color="blue">在售</Tag>;
            } else {
              return <Tag color="red">停售</Tag>;
            }
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '160'
        }
      ]
    };
  },

  mounted() {
    this.searchAjax();
    this.queryInsuranceCompanyList();
  },

  methods: {
    searchAjax(reset) {
      this.pageNum = 1;
      // 切换tabs分类
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.getThemeList(params);
      if (reset !== true && this.status != '0' && this.isAdd == '0') {
        this.tabActive = '0';
        this.getList(params);
      } else {
        params.themeId = this.tabActive;
        this.getList(params);
      }
    },

    getList(params) {
      if (!this.activityId) return;
      this.listLoading = true;
      this.$http({
        url: '/buz/merchantActivity/queryProductConfigList',
        type: 'POST',
        data: {
          ...params,
          activityProductType: this.productType + '',
          activityId: this.activityId,
          queryConfigProduct: true,
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          res.data.records.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.productCode == item2.productCode) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.data.total;
          this.tableData = res.data.records;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    getThemeList(params) {
      delete params.themeId;
      this.$http({
        url: '/buz/merchantActivity/queryAllTheme',
        type: 'POST',
        data: {
          ...params
        }
      }).then(res => {
        this.themeList = res.data;
      });
    },

    changeOriginSupplierType(value) {
      this.searchParams.supplierIds = [];
      if (!value) {
        this.supplierList = [];
        return;
      }
      this.$http({
        url: value == 1 ? '/buz/insuranceCompany/read/list' : '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (value) {
          this.supplierList = res.data.map(i => {
            return {
              value: i.id,
              label: i.name
            };
          });
        } else {
          this.supplierList = [];
        }
      });
    },

    // 查询签约保司
    queryInsuranceCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/list',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },

    showEdit(row = {}) {
      this.openPageTabTags('/productResource/productManager/productDetail', {
        id: row.productId,
        code: row.productCode,
        isCopy: row.isCopy,
        timeStr: new Date().getTime()
      });
    },

    del(row) {
      this.$notice.inquiry(`确认删除该数据吗？`).then(() => {
        this.$http({
          url: '/buz/merchantActivity/batchDeleteProductMainConfig',
          type: 'POST',
          data: {
            activityId: this.activityId,
            productCodeList: [row.productCode]
          }
        }).then(res => {
          this.getList(JSON.parse(JSON.stringify(this.searchParams)));
          this.$notice.success('删除成功');
        });
      });
    },

    batchDelete() {
      if (!this.selectArr.length && !this.isAll) {
        this.$notice.msg('请至少选择一个产品');
        return;
      }
      let data = {};
      if (this.isAll) {
        data = {
          activityId: this.activityId,
          isAll: true,
          query: {
            ...this.searchParams
          }
        };
      } else {
        data = {
          activityId: this.activityId,
          productCodeList: this.selectArr.map(item => item.productCode)
        };
      }
      this.$notice.inquiry(`确认删除该数据吗？`).then(() => {
        console.log(data);
        this.$http({
          url: '/buz/merchantActivity/batchDeleteProductMainConfig',
          type: 'POST',
          data
        }).then(res => {
          this.isAll = false;
          this.getList(JSON.parse(JSON.stringify(this.searchParams)));
          this.$notice.success('删除成功');
        });
      });
    },

    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },

    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.productCode); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.productCode); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.productCode) && !selectIds.includes(item.productCode)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.productCode);
        } else if (!ids.includes(item.productCode) && selectIds.includes(item.productCode)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.productCode), 1);
          selectIds.splice(selectIds.indexOf(item.productCode), 1);
        }
      });
    },

    // 修改是否同步产品
    changeSyncProductType(value) {
      this.$emit('setSyncProductType', value);
    },

    // 费用配置
    openGradeConfig(row) {
      this.$refs.gradeConfig.open(row, this.activityId);
    },

    // 分页
    changePage(num) {
      this.pageNum = num;
      this.getList(JSON.parse(JSON.stringify(this.searchParams)));
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  height: 45px;
  overflow: hidden;
  &.open {
    height: auto;
  }

  .input-item {
    width: 30%;
    min-width: 240px;
    display: flex;
    margin-bottom: 15px;
    align-items: center;
    .label {
      font-size: 13px;
    }

    /deep/ .ivu-input {
      font-size: 13px;
    }

    /deep/ .ivu-select-selected-value {
      font-size: 13px;
    }
  }
  @media screen and (max-width: 1330px) {
    .input-item {
      width: 50%;
    }
  }

  .btn-item {
    display: flex;
    margin-left: auto;
    .reset-btn {
      background-color: #fff;
      color: #236dff;
      border: 1px solid #236dff;
      margin-left: 10px;
    }
    .close-open {
      width: 80px;
      height: 30px;
      border-radius: 2px;
      background-color: #fff;
      color: #236dff;
      border: 1px solid #236dff;
      margin-left: 10px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}
/deep/.productName {
  width: 100%;
  > .ivu-tooltip-rel {
    width: 100%;
    > span {
      width: 100%;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
      cursor: pointer;
      color: #236dff;
      text-decoration: underline;
    }
  }
}
.right-box {
  display: flex;
  .sync-switch {
    display: flex;
    align-items: center;
    .label {
      margin-right: 10px;
    }
  }
}
</style>
